export interface userState {
  id: string;
  name: string;
  company: string;
  isAuth: boolean;
  isPermission: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
}

export interface categoryType {
  key: string;
  value: string;
}

export interface scrapInfoType {
  pk: string;
  sk: string;
  image_list: any;
  ai_title: string;
  keyword: string;
}

export interface briefInfoType {
  pk: string;
  sk: string;
  image_list: any;
  ai_title: string;
  ai_report: string;
  title: string;
  ref_site: string;
  ai_keyword: any;
  ai_introduction: string;
  ai_insight?: any;
  ai_OriginContent: string;
  ai_KorOriginContent: string;
  keyword: string;
  show_pk: string;
  search_list: any;
}

export interface scrapInfoType {
  pk: string;
  sk: string;
  default_image_list?: any;
  scrap_key_list?: any;
  scrap_title: string;
  user_id: string;
  scrap_status?: string;
  selectedKeywords?: any;
}

export interface reportIdentifierType {
  pk: string;
  sk: string;
  user_id: string;
  report_title: string;
  report_keyword: any;
  scrap_info: any;
}

export interface reportInfoType {
  pk: string;
  sk: string;
  scrap_img?: any;
  scrap_Insight?: string;
  scrap_introduction?: string;
  scrap_Strategies?: any;
  scrap_keyword?: string;
  scrap_list?: any;
  scrap_status?: string;
  scrap_title?: string;
  // extra_key?: string;
  // report_list?: any;
  // report_status?: string;
  // report_title?: string;
  // scrap_status?: string;
  // report_type?: string;
  // scrap_info?: any;
  // source_list?: any;
  // user_id?: string;
}

export const aitbSearchPeriods: any = [
  { key: "recent", title: "최신" },
  { key: "week", title: "일주일" },
  { key: "month", title: "한달" },
  { key: "quarter", title: "분기" },
];

export const scrapListSearchPeriods: any = [
  { key: "recent", title: "최근" },
  { key: "week", title: "지난1주" },
  { key: "month", title: "지난1개월" },
  { key: "halfYear", title: "지난6개월" },
];

export const scrapDetailSwitch: any = [
  { key: "keyword", title: "키워드별" },
  { key: "category", title: "카테고리별" },
];

export const lastListCookieId = "aitbLastList";
export const lastSelectedKeywordsCookieID = "aitbLastKeywords";
export const lastSelectedPeriod = "aitbLastPeriod";
export const lastSelectedCategory = "aitbLastCategory";
export const lastScrollPosition = "aitbLastScrollPosition";
export const lastBriefListLength = "aitbLastBriefListLength";
